import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineDownloadTray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#3752B3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M2.225 12.725a2.1 2.1 0 0 0 2.1 2.1h7.35a2.1 2.1 0 0 0 2.1-2.1M5.375 8 8 10.625 10.625 8M8 10.625v-9.45"
    />
  </svg>
);
export default SvgStreamlineDownloadTray;
